/**
****************************************************
***                        *******    ******    ****
***                        ******    ******    *****
***********       **************    ******    ******
***********       *************    ******    *******
***********       ************    ******    ********
***********       ***********    ******    *********
***********       **********    ******    **********
***********       *********    ******    ***********
***********       ********    ******    ************
***********       *******    ******    *************
***********       ******    ******    **************
****************************************************
* --------------------------------------------------
* Travlr UiKit: travlruikit.js
* By Travlr Team
*
* For Initialize Travlr Uikit Javascript
* --------------------------------------------------
*/

import './js/utils/querySelector'
import UiKit from './js'

if (typeof window.$TravlrSelector === 'undefined') {
  throw new Error('TravlrUikit requires Sizzle js. Sizzle must be include before TravlrUikit Javascript.')
}

// Const
const NAME = 'TravlrUikit'

class TravlrUikit {
  constructor (config) {
    this._config = config

    if (this._config) {
      window[NAME] = this._config
    } else {
      window[NAME] = UiKit
    }
  }
}

// Default Initialize
new TravlrUikit()

// Feel free to customize Travlr Uikit Parts
export default TravlrUikit
